/*
 * Copyright (c) 2018 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Injectable } from '@angular/core';

import { DataQuery } from '@typescript-kit/data';
import { HttpService } from '@angular-kit/core';

import { ValidityPeriod } from '@teamworks/global';

@Injectable()
export class ValidityPeriodService {

  constructor(private httpService: HttpService) {
  }

  async loadValidityPeriodList(targetType: string, dataQuery?: DataQuery): Promise<ValidityPeriod[]> {
    return this.httpService.get(`api/base-data/validity-period-list/${targetType}`, { 'data-query': dataQuery });
  }

  async loadValidityPeriod(id: string, dataQuery?: DataQuery): Promise<ValidityPeriod> {
    return this.httpService.get(`api/base-data/validity-period/${id}`, { 'data-query': dataQuery });
  }

  async saveValidityPeriod(data: ValidityPeriod): Promise<ValidityPeriod> {
    return this.httpService.post(`api/base-data/validity-period`, data);
  }

  async deleteValidityPeriod(id: string): Promise<ValidityPeriod> {
    return this.httpService.delete(`api/base-data/validity-period/${id}`);
  }
}
